import React from 'react'
import { Box } from '@mui/material'
import QuestionSetItem from './QuestionSetItem'
import { selectQuestionSets } from '../../../reducers/survey_questionset'
import { useSelector } from 'react-redux'
/**
 * 
 
questions={quizState.Questions}
authtoken={currentUser.AuthToken}
responseguid={quizState.ResponseGuid}
startfromBeginning={quizState.StartFromBeginning}
uom={quizState.UnitOfMeasure}
validationMessages={ValidationMessages}
questionPrompts={QuestionPrompts}
updateQuestionTotal={updateQuestionTotal}
updateQuestionsAnswered={updateQuestionsAnswered}
setCurrentIndex={setCurrentIndex} 
completeSuccessful={completeSuccessful}/>
*/

const QuestionSetContainer=(props)=>{
    
    const QuestionSets = useSelector(state=> selectQuestionSets(state))
    
    return (

        <Box p={2} >
            {
                QuestionSets && QuestionSets.sort((a,b) => a.QuestionSetSequence - b.QuestionSetSequence).map((x,i)=>{
                    return (
                        <QuestionSetItem QuestionSet={x} key={"QS_"+x.QuestionSetId} responseGuid={props.responseGuid}/>
                    )
                })
            }
        </Box>
    )

}

export default QuestionSetContainer